export const STRING_OPERATORS = [
  'IS',
  'IS_NOT',
  'INCLUDES',
  'DOES_NOT_INCLUDE',
] as const;
export const NUMBER_OPERATORS = ['IS', 'IS_NOT', 'GT', 'LT'] as const;
export const DATE_OPERATORS = ['IS', 'IS_NOT', 'GT', 'LT'] as const;
export const ENUM_OPERATORS = ['IS', 'IS_NOT'] as const;

export type StringOperator = (typeof STRING_OPERATORS)[number];
export type NumberOperator = (typeof NUMBER_OPERATORS)[number];
export type DateOperator = (typeof DATE_OPERATORS)[number];
export type EnumOperator = (typeof ENUM_OPERATORS)[number];
export type FilterOperator =
  | StringOperator
  | NumberOperator
  | DateOperator
  | EnumOperator;

export type FieldType = 'string' | 'number' | 'date' | 'enum';

export const OPERATORS_BY_TYPE: Record<FieldType, readonly FilterOperator[]> = {
  string: STRING_OPERATORS,
  number: NUMBER_OPERATORS,
  date: DATE_OPERATORS,
  enum: ENUM_OPERATORS,
};

export const OPERATOR_LABELS: Record<FilterOperator, string> = {
  IS: 'is',
  IS_NOT: 'is not',
  INCLUDES: 'includes',
  DOES_NOT_INCLUDE: 'does not include',
  GT: '>=',
  LT: '<=',
};

export function getOperatorDisplayLabel(
  operator: FilterOperator,
  value: string | number | string[] | null,
): string {
  if (operator === 'IS') {
    return Array.isArray(value) && value.length > 1 ? 'any of' : 'is';
  }
  if (operator === 'IS_NOT') {
    return Array.isArray(value) && value.length > 1 ? 'none of' : 'is not';
  }
  return OPERATOR_LABELS[operator];
}

export type EnumOption = {
  value: string;
  label: string;
};

export type FieldConfig = {
  id: string;
  label: string;
  type: FieldType;
  enumOptions?: EnumOption[];
  suggestions?: string[];
  /** Sentinel value for matching empty/NULL facets. Usually `""`. */
  emptySentinelValue?: string;
};

export type QueryBuilderConfig = {
  fields: FieldConfig[];
  allowNestedGroups?: boolean;
  maxNestingDepth?: number;
  /** Value used to represent "empty" field value. No is/includes options are generated for this on any field. */
  emptySentinelValue?: string;
};

export type FilterCondition = {
  id: string;
  /** Use ANY_FIELD_ID for "any field containing" filters */
  fieldId: string;
  operator: FilterOperator;
  value: string | number | string[] | null;
};

export type FilterLogic = 'AND' | 'OR';

export type FilterGroup = {
  id: string;
  logic: FilterLogic;
  conditions: FilterItem[];
};

export type FilterItemCondition = {
  type: 'condition';
  condition: FilterCondition;
};

export type FilterItemGroup = {
  type: 'group';
  group: FilterGroup;
};

export type FilterItem = FilterItemCondition | FilterItemGroup;

export type FilterState = {
  topLevelLogic: FilterLogic;
  items: FilterItem[];
};

export const ANY_FIELD_ID = 'any';
export const DEFAULT_MAX_NESTING_DEPTH = 2;
